module.exports = __webpack_public_path__ + "static/media/daniel_kao.0e2e4b8a.png";